import {
  type PersonalInformationFormFieldsProps,
  type BlockedRecordInfoFormFieldsProps,
  PersonalInformationFormFields,
  BlockedRecordInfoFormFields,
  type BlockRecordInfoFormFieldsVariant,
} from '@exam-center/blocked-user-management';
import { Link } from '@exam-center/router';
import { Button, Flex, Form, FormButton, type FormProps, PaperSection } from '@shared/components';

export type BlockedUserCreationFormProps = Omit<
  Extract<PersonalInformationFormFieldsProps, { mode: 'create' }>,
  'mode'
> &
  BlockedRecordInfoFormFieldsProps &
  FormProps & {
    submitting: boolean;
  } & {
    variant: BlockRecordInfoFormFieldsVariant;
  };

export default function BlockedUserCreationForm(props: Readonly<BlockedUserCreationFormProps>) {
  const {
    fields,
    submitting: isSubmitting,
    visibleFields,
    visibleSections,
    options,
    variant,
    ...restProps
  } = props;

  return (
    <Form {...restProps}>
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
      >
        <PaperSection title='ข้อมูลส่วนตัว'>
          <PersonalInformationFormFields mode='create' fields={fields} />
        </PaperSection>
        <PaperSection title='ข้อมูลการระงับสิทธิ์สอบ'>
          <BlockedRecordInfoFormFields
            fields={fields}
            options={options}
            visibleFields={visibleFields}
            visibleSections={visibleSections}
            variant={variant}
          />
        </PaperSection>
        <Flex sx={(theme) => ({ flex: 1, justifyContent: 'flex-end', gap: theme.spacing(3) })}>
          <Button
            component={Link}
            to='/admin/blocklist'
            size='large'
            color='secondary'
            variant='outlined'
            disabled={isSubmitting}
          >
            ยกเลิก
          </Button>
          <FormButton label='เพิ่มรายชื่อ' size='large' loading={isSubmitting} />
        </Flex>
      </Flex>
    </Form>
  );
}
